<template>
  <!-- 헤더 영역 -->
  <header>
    <div class="inner">
      <h1 id="logo">
        <a>
          <img :src="require('@/assets/images/logo.png')" alt="대구로" />
          <em>고객지원</em>
        </a>
      </h1>
      <!-- 모바일 메뉴 버튼 -->
      <button type="button" class="btnMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
  <!-- 메인 컨테이너 -->
  <div class="container" id="home">
    <div class="inner">
      <div id="content">
        <div class="infoBox">
          <p>
            안녕하세요, 대구로 고객지원입니다. <br />원하시는 서비스를
            선택하시면 해당 서비스로 이동합니다.
          </p>
          <ul>
            <li v-for="(row, idx) in serviceUserData" :key="idx">
              <a @click.prevent="move(row.serviceCode)"
                ><img
                  class="iconImg"
                  :src="`${baseURL}/faqImage/${row.serviceIconName}`"
                /><span>{{ row.serviceName }}</span></a
              >
            </li>
          </ul>
        </div>
        <div class="faq">
          <div class="faqTitle">
            <em>자주하는 질문</em>
            <a @click.prevent="move()">더보기</a>
          </div>
          <div class="faqListWrap">
            <dl v-for="(row, idx) in dataList" :key="idx">
              <dt class="tit" @click="getAnswerBody(`${idx}-${1}`)">
                <em class="type" @click="move(row.serviceCode, row.userCode)"
                  >[{{ row.serviceName }} > {{ row.userName }}]</em
                >
                {{ row.questionTitle }}
              </dt>
              <dd
                class="txt"
                v-show-slide:500:ease="selectFaqIndex === `${idx}-${1}`"
                v-html="row.answerBody"
              ></dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 모바일 메뉴 관련 요소들 -->
  <div class="mask"></div>
  <button type="button" id="top"><span>top</span></button>
  <!-- 모바일 메뉴 -->
  <div class="mobileMenuWrap">
    <div class="mobileLogo">
      <img :src="require('@/assets/images/logo.png')" alt="대구로" />
      <em>고객지원</em>
      <button type="button" class="close">모바일 메뉴 닫기</button>
    </div>
    <ul class="mobileMenu">
      <li v-for="(row, idx) in serviceUserData" :key="idx">
        <em :class="'tit ' + 'menuIco'">
          <img
            class="iconImg"
            :src="`${baseURL}/faqImage/${row.serviceIconName}`"
          />
          {{ row.serviceName }}</em
        >
        <ul class="dash dot">
          <li
            v-for="(user, userIndex) in row.users"
            :key="userIndex"
            :class="{ on: this.userCode === user.userCode }"
          >
            <a
              @click.prevent="
                move(row.serviceCode, user.userCode), removeMobileMenu()
              "
            >
              {{ user.userName }}
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  emits: ["move"],
  data: () => ({
    baseURL: "",
    serviceCode: "",
    serviceName: "",
    userCode: "",
    userName: "",
    type: [],
    typeCode: "",
    serviceUserData: [],
    dataList: [],
    selectFaqIndex: null,
  }),
  mounted() {
    // 환경에 따른 baseURL 설정
    process.env.NODE_ENV === "production"
      ? (this.baseURL = "https://ext.daeguro.co.kr:45010")
      : (this.baseURL = "https://dgpub.282.co.kr:8502");
    // 이벤트 리스너 등록 및 초기 데이터 로드
    window.addEventListener("resize", this.handleResize);
    this.getFaqServiceUserList();
    // 모바일 메뉴 제거 함수
    function mobileRemove() {
      $(".mobileMenuWrap").removeClass("on");
      $(".mask").removeClass("on");
    }
    // jQuery를 사용한 UI 이벤트 처리
    $(function () {
      // 검색 버튼 클릭 이벤트
      $(".btnSearch").click(function () {
        $(this).toggleClass("on");
        $(".search.mobile").slideToggle();
      });
      // 메뉴 버튼 클릭 이벤트
      $(".btnMenu").click(function () {
        $(this).toggleClass("on");
        $(".mobileMenuWrap").addClass("on");
        $(".mask").toggleClass("on");
      });
      // 모바일 메뉴 닫기 이벤트
      $(".mobileMenuWrap .close").click(function () {
        mobileRemove();
      });
      // 창 크기 변경 시 모바일 메뉴 처리
      $(window).on("load resize", function () {
        var w = $(window).width();
        var x = 1024;
        if (w > x) {
          mobileRemove();
        }
      });

      // TOP 버튼 관련 이벤트
      $("#top").click(function () {
        $("html, body").stop().animate(
          {
            scrollTop: 0,
          },
          500
        );
      });
      // 스크롤 이벤트
      $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
          $("#top").addClass("on");
        } else {
          $("#top").removeClass("on");
        }
      });
    });
  },
  methods: {
    // FAQ 서비스 및 사용자 목록 조회
    async getFaqServiceUserList() {
      await this.$axios
        .get("/SupportFAQ/GetFAQService")
        .then(async (response) => {
          const filteredServices = response.data.data.filter(
            (service) => service.useGbn === "Y"
          );
          for (const item of filteredServices) {
            await this.$axios
              .get(`/SupportFAQ/GetFAQUser?serviceCode=${item.serviceCode}`)
              .then(async (response) => {
                const filteredUsers = response.data.data.filter(
                  (user) => user.useGbn === "Y"
                );
                const users = filteredUsers.map((user) => {
                  return {
                    userCode: user.userCode,
                    userName: user.userName,
                    serviceCode: user.serviceCode,
                    memo: user.memo,
                    dispSeq: user.dispSeq,
                    categoryCode: user.categoryCode,
                    useGbn: user.useGbn,
                  };
                });
                this.serviceUserData.push({
                  serviceCode: item.serviceCode,
                  serviceName: item.serviceName,
                  serviceIconName: item.iconName,
                  users: users,
                });
              });
          }
          await this.getFaqTypeList(this.serviceCode, this.userCode);
        });
    },
    // FAQ 타입 목록 조회
    async getFaqTypeList(serviceCode, userCode) {
      await this.$axios
        .get(
          `/SupportFAQ/GetFAQType?serviceCode=${serviceCode}&userCode=${userCode}`
        )
        .then(async (response) => {
          const filteredTypes = response.data.data.filter(
            (type) => type.useGbn === "Y"
          );
          this.type = filteredTypes.map((type) => {
            return {
              typeCode: type.typeCode,
              typeName: type.typeName,
              userCode: type.userCode,
              serviceCode: type.serviceCode,
              categoryCode: type.categoryCode,
              memo: type.memo,
              dispSeq: type.dispSeq,
              useGbn: type.useGbn,
            };
          });
        });
      this.typeCode = this.type[0] ? this.type[0].typeCode : 0;
      await this.getFaqList();
    },
    // FAQ 목록 조회
    async getFaqList() {
      this.dataList = null;
      await this.$axios
        .get(`/SupportFAQ/GetFAQ?useGbn=Y&inFavoriteGbn=Y&div=1`)
        .then(async (response) => {
          const filteredFaq = response.data.data.filter(
            (faq) => faq.useGbn === "Y"
          );
          this.dataList = filteredFaq.map((data) => {
            return {
              faqCode: data.faqCode,
              serviceCode: data.serviceCode,
              serviceName: data.serviceName,
              userCode: data.userCode,
              userName: data.userName,
              typeCode: data.typeCode,
              typeName: data.typeName,
              useGbn: data.useGbn,
              questionTitle: data.questionTitle,
              answerBody: data.answerBody,
              insDate: data.insDate,
              insUcode: data.insUcode,
              insUname: data.insUname,
              modDate: data.modDate,
              modUcode: data.modUcode,
              modUname: data.modUname,
            };
          });
          this.dataList = this.dataList.slice(0, 5);
        });
    },
    // FAQ 답변 표시/숨김 토글
    getAnswerBody(idx) {
      this.selectFaqIndex = this.selectFaqIndex === idx ? null : idx;
    },
    // 화면 이동
    move(serviceCode, userCode) {
      this.$emit("move", "main", serviceCode, userCode);
    },
    // 화면 크기 변경 처리
    handleResize() {
      this.isMobile = window.innerWidth <= 992;
    },
    // 모바일 메뉴 제거
    removeMobileMenu() {
      $(".mobileMenuWrap").removeClass("on");
      $(".mask").removeClass("on");
    },
  },
};
</script>
